import React, { useEffect, useState } from 'react'
import { useForm, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Form } from 'semantic-ui-react'
import MilkMoneyAccountingService, { ToursRowType } from '~/api/services/milkMoneyAccounting'
import Dialog from '~/components/Dialog'
import { FormFields } from '~/components/FormFields'
import notify from '~/components/Notify'
import { handleErrors } from '~/utils/helpers'

interface Props {
  deleteTour: ToursRowType
  handleClose: () => void
  handleSubmitDelete: () => void
}

const DeleteTourModal: React.FC<Props> = (props) => {
  const { t } = useTranslation()
  const { handleClose, handleSubmitDelete, deleteTour } = props

  const [isBusyDeletingTour, setIsBusyDeletingTour] = useState(false)

  const { control, handleSubmit, reset } = useForm({
    mode: 'onSubmit'
  })

  useEffect(() => {
    if (deleteTour) {
      reset({
        comment: ''
      })
    }
  }, [deleteTour])

  const watchComment = useWatch({ control, name: 'comment' })

  async function onSubmit(data) {
    setIsBusyDeletingTour(true)
    try {
      await MilkMoneyAccountingService.deleteTour(deleteTour?.id, data)
      notify(t('Successfully delete tour'), 'success')
      handleSubmitDelete()
    } catch (error) {
      handleErrors(error)
    } finally {
      setIsBusyDeletingTour(false)
    }
  }

  return <Dialog
    isDialogOpen={Boolean(deleteTour)}
    handleClose={() => handleClose()}
    typeButton='submit'
    formId='delete-tour-form'
    textHeader={`Tour [${deleteTour?.tourNumber}] löschen`}
    textContent={<Form id='delete-tour-form' onSubmit={handleSubmit(onSubmit)}>
      <div style={{ marginBottom: '1em' }}>{`Möchten Sie die Tour [${deleteTour?.tourNumber}] wirklich löschen? 
        Die darin enthaltenen Milchanlieferungen werden dann im Rahmen der Milchgeldabrechnung für die jeweiligen Landwirte nicht mehr berücksichtigt.`}</div>
      <FormFields.TextArea
        name='comment'
        control={control}
        label={'Anmerkung/Begründung:'}
        rules={{
          required: t('Please enter comment'),
          maxLength: {
            value: 1000,
            message: t('Max char. is 1000')
          }
        }}
      />
      <small>{t('Characters: {{count}} (max 1000)', { count: watchComment?.length || 0 })}</small>
    </Form>}
    isLoading={isBusyDeletingTour}
    textClose='Nein'
    textSubmit={'Löschen'}
  />
}
export default DeleteTourModal